import { render } from "./CoachRequest.vue?vue&type=template&id=3305ef00&scoped=true"
import script from "./CoachRequest.vue?vue&type=script&lang=js"
export * from "./CoachRequest.vue?vue&type=script&lang=js"

import "./CoachRequest.vue?vue&type=style&index=0&id=3305ef00&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3305ef00"]])

export default __exports__